/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SOffenderRecordsReport } from './SOffenderRecordsReport';
import {
    SOffenderRecordsReportFromJSON,
    SOffenderRecordsReportFromJSONTyped,
    SOffenderRecordsReportToJSON,
    SOffenderRecordsReportToJSONTyped,
} from './SOffenderRecordsReport';

/**
 * 
 * @export
 * @interface GenerateSOffenderRecordsReport200ResponseData
 */
export interface GenerateSOffenderRecordsReport200ResponseData {
    /**
     * 
     */
    data?: SOffenderRecordsReport;
}

/**
 * Check if a given object implements the GenerateSOffenderRecordsReport200ResponseData interface.
 */
export function instanceOfGenerateSOffenderRecordsReport200ResponseData(value: object): value is GenerateSOffenderRecordsReport200ResponseData {
    return true;
}

export function GenerateSOffenderRecordsReport200ResponseDataFromJSON(json: any): GenerateSOffenderRecordsReport200ResponseData {
    return GenerateSOffenderRecordsReport200ResponseDataFromJSONTyped(json, false);
}

export function GenerateSOffenderRecordsReport200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateSOffenderRecordsReport200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SOffenderRecordsReportFromJSON(json['data']),
    };
}

export function GenerateSOffenderRecordsReport200ResponseDataToJSON(json: any): GenerateSOffenderRecordsReport200ResponseData {
    return GenerateSOffenderRecordsReport200ResponseDataToJSONTyped(json, false);
}

export function GenerateSOffenderRecordsReport200ResponseDataToJSONTyped(value?: GenerateSOffenderRecordsReport200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SOffenderRecordsReportToJSON(value['data']),
    };
}

